import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { InputMask, InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import { StepperModule } from 'primeng/stepper';
import { TextareaModule } from 'primeng/textarea';
import {
  InstituicaoGestoraService,
  CommunicationService,
} from '../../api/services';
import { MessageService } from 'primeng/api';
import { ApiService } from '@core/providers/http';
import { Fluid } from 'primeng/fluid';
import { FileUploadModule } from 'primeng/fileupload';
import { InstituicaoNaturezaEnum } from '../../api/models/institutionNaturezaEnum';
import { RadioButton, RadioButtonModule } from 'primeng/radiobutton';
import { Subscription } from 'rxjs';
import { DropdownModule } from 'primeng/dropdown';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { MenuModule } from 'primeng/menu';
import { InputGroup } from 'primeng/inputgroup';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-edit-instituicoes-gestora',
  imports: [
    FormsModule,
    InputMask,
    Fluid,
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    Select,
    InputTextModule,
    TextareaModule,
    ButtonModule,
    InputMaskModule,
    StepperModule,
    FileUploadModule,
    RadioButton,
    Toast,
    StepperModule,
    InputMask,
    RadioButtonModule,
    DropdownModule,
    InputGroupAddonModule,
    MenuModule,
    InputGroup,
  ],
  providers: [
    DialogService,
    InstituicaoGestoraService,
    MessageService,
    ApiService,
  ],
  templateUrl: './edit-instituicoes-gestora.component.html',
  styleUrl: './edit-instituicoes-gestora.component.scss',
  standalone: true,
})
export class EditInstituicoesGestoraComponent implements OnInit {
  addEmpresaGestoraForm!: FormGroup;
  activeStep: number = 1;
  apiService = inject(ApiService);
  tipoInstituicaoGestoras: any[] = [];
  tipoEmpresas: any[] = [];

  messageService = inject(MessageService);
  dialogService = inject(DialogService);
  instituicaoGestoraService = inject(InstituicaoGestoraService);
  naturezasID = [
    { id: InstituicaoNaturezaEnum.Publica, designacao: 'Pública' },
    { id: InstituicaoNaturezaEnum.Privada, designacao: 'Privado' },
  ];
  ref = inject(DynamicDialogRef);
  fb = inject(FormBuilder);
  config = inject(DynamicDialogConfig);

  file: any;
  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL
  selectedFile: File | null = null;
  private communicationService = inject(CommunicationService);
  countries: any[] = [];
  provinces: any[] = [];
  municipalities: any[] = [];
  private subscriptions = new Subscription();

  selectedCountry: any = null;

  telefoneMask: string = '';
  telefonePlaceholder: string = '';

  countryMenuItems = [
    {
      label: 'Angola (+244)',
      command: () => this.setPhoneMask('AO'),
    },
    {
      label: 'Brasil (+55)',
      command: () => this.setPhoneMask('BR'),
    },
    {
      label: 'Portugal (+351)',
      command: () => this.setPhoneMask('PT'),
    },
    {
      label: 'Estados Unidos (+1)',
      command: () => this.setPhoneMask('US'),
    },
    {
      label: 'Reino Unido (+44)',
      command: () => this.setPhoneMask('UK'),
    },
  ];

  // Validators.pattern(/^244\ \d{3} \d{3} \d{3}$/)
  constructor() {
    this.tipoInstituicaoGestoras = this.config.data.tipoInstituicaoGestoras;
    this.addEmpresaGestoraForm = this.fb.group({
      id: [0],
      Nome: ['', Validators.required],
      Endereco: [''],
      telefone1: ['', [Validators.required]],
      telefone2: [''],
      email: ['', [Validators.required, Validators.email]],
      paisID: ['', Validators.required],
      ProvinciaID: ['', Validators.required],
      MunicipioID: ['', Validators.required],
      Site: [''],
      Natureza: ['', Validators.required],
      Activo: [true],
      Foto: [''], // novo campo
    });

    this.addEmpresaGestoraForm.controls['paisID'].valueChanges.subscribe(
      (value) => {
        if (!value) return;
        this.onCountryChange(value);
      }
    );

    this.addEmpresaGestoraForm.controls['ProvinciaID'].valueChanges.subscribe(
      (value) => {
        if (!value) return;
        this.onProvinceChange(value);
      }
    );

    this.countries = this.config.data.countries;
    this.provinces = this.config.data.provinces;
    this.municipalities = this.config.data.municipalities;
  }

  ngOnInit(): void {
    if (
      this.config.data.perfilEmpresagestora &&
      this.config.data.perfilEmpresagestora.id
    ) {
      this.imagePreview =
        this.config.data.perfilEmpresagestora.Foto ||
        this.config.data.imagePreview;
      this.loadEmpresaGestoraDetails(this.config.data.perfilEmpresagestora);
      const pais = this.config.data.perfilEmpresagestora.pais || '';
      this.setPhoneMaskByCountryName(pais);
    }

    this.subscriptions.add(
      this.communicationService.provinces$.subscribe((provinces) => {
        this.provinces = provinces;
      })
    );
    this.subscriptions.add(
      this.communicationService.municipalities$.subscribe((municipalities) => {
        this.municipalities = municipalities;
      })
    );
  }

  loadEmpresaGestoraDetails(perfilEmpresagestora: any): void {
    this.addEmpresaGestoraForm.patchValue({
      id: perfilEmpresagestora.id,
      Nome: perfilEmpresagestora.nome,
      Endereco: perfilEmpresagestora.endereco,
      telefone1: perfilEmpresagestora.telefone1,
      telefone2: perfilEmpresagestora.telefone2,
      paisID: perfilEmpresagestora.paisID,
      ProvinciaID: perfilEmpresagestora.provinciaID,
      MunicipioID: perfilEmpresagestora.municipioID,
      email: perfilEmpresagestora.email,
      Site: perfilEmpresagestora.site,
      Natureza: perfilEmpresagestora.natureza,
      Activo: true,
      Foto: perfilEmpresagestora.Foto,
    });
  }

  onCountryChange(value: any) {
    this.communicationService.emitCountryChanged(value);
    // this.resetProvinceAndMunicipality();
  }

  resetProvinceAndMunicipality() {
    this.addEmpresaGestoraForm.patchValue({
      ProvinciaID: null,
      MunicipioID: null,
    });
  }

  resetMunicipality() {
    this.addEmpresaGestoraForm.patchValue({
      MunicipioID: null,
    });
  }

  onProvinceChange(value: any) {
    this.communicationService.emitProvinceChanged(value);
    // this.resetMunicipality();
  }

  // Novo método para setar máscara pelo nome do país
  setPhoneMaskByCountryName(countryName: string) {
    if (!countryName) {
      this.telefoneMask = '';
      this.telefonePlaceholder = '';
      return;
    }
    const name = countryName.toLowerCase();
    if (name.includes('angola')) {
      this.setPhoneMask('AO');
    } else if (name.includes('brasil')) {
      this.setPhoneMask('BR');
    } else if (name.includes('portugal')) {
      this.setPhoneMask('PT');
    } else if (
      name.includes('united kingdom') ||
      name.includes('reino unido')
    ) {
      this.setPhoneMask('UK');
    } else if (
      name.includes('estados unidos') ||
      name.includes('united states')
    ) {
      this.setPhoneMask('US');
    } else {
      this.telefoneMask = '';
      this.telefonePlaceholder = '';
    }
  }

  // Example method to change mask
  setPhoneMask(countryCode: string): void {
    switch (countryCode) {
      case 'AO':
        this.telefoneMask = '(244) 999-999-999';
        this.telefonePlaceholder = '(+244) 999-999-999';
        break;
      case 'BR':
        this.telefoneMask = '(99) 99999-9999';
        this.telefonePlaceholder = '(+55) 99999-9999';
        break;
      case 'PT':
        this.telefoneMask = '(999) 999-999-999';
        this.telefonePlaceholder = '(+351) 999 999 999';
        break;
      case 'US':
        this.telefoneMask = '(999) 999-9999';
        this.telefonePlaceholder = '(+1) 999-999-9999';
        break;
      case 'UK':
        this.telefoneMask = '99999 999999';
        this.telefonePlaceholder = '(+44) 99999 999999';
        break;
      default:
        this.telefoneMask = '';
        this.telefonePlaceholder = '';
    }

    // this.addEmpresaGestoraForm.get('telefone1')?.reset();
  }

  choose(event: any, callback: () => void) {
    callback();
  }

  onSelectedFiles(event: { currentFiles: any }) {
    this.file = event.currentFiles[0];

    //Adicionar validação de tamanho da imagem (ex: máx. 2MB)
    const maxSizeMB = 2;
    if (this.file.size > maxSizeMB * 1024 * 1024) {
      this.messageService.add({
        severity: 'error',
        summary: 'Imagem muito grande',
        detail: `A imagem deve ter no máximo ${maxSizeMB}MB.`,
        life: 3000,
      });
      return;
    }

    const isImage = this.file.type.startsWith('image/');
    if (!isImage) {
      this.messageService.add({
        severity: 'error',
        summary: 'Formato inválido',
        detail: 'Apenas imagens são permitidas.',
        life: 3000,
      });
      return;
    }

    if (this.file) {
      this.selectedFile = this.file;
      this.addEmpresaGestoraForm.patchValue({ Foto: this.file });
      
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    }
    /*this.file = event.currentFiles[0];
    console.log(this.file);
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result; // Store Base64 URL
    };
    reader.readAsDataURL(this.file);*/
  }

  save(): void {
    console.log(this.addEmpresaGestoraForm.value);

    if (this.addEmpresaGestoraForm.invalid) {
      this.addEmpresaGestoraForm.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Por favor, preencha todos os campos obrigatórios.',
      });
      return;
    }
    if (this.addEmpresaGestoraForm.value) {
      const rawData = this.addEmpresaGestoraForm.getRawValue();
      const formData = new FormData();
      for (const key in rawData) {
        if (key !== 'Foto') {
          if (!rawData[key]) continue;
          formData.append(key, rawData[key]);
        }
      }

      // formData.append('DescricaoEmpresa', rawData.DescricaoEmpresa);
      // formData.append('id', rawData.id);
      // formData.append('Nome', rawData.Nome);
      // formData.append('telefone1', rawData.telefone1);
      // formData.append('Sigla', rawData.Sigla);
      // formData.append('telefone2', rawData.telefone2);
      // formData.append('Site', rawData.Site);
      // formData.append('Endereco', rawData.Endereco);
      // formData.append('email', rawData.email);
      // formData.append('Natureza', rawData.Natureza);
      // formData.append('Activo', rawData.Activo);
      if (rawData.Foto && this.selectedFile) {
        formData.append('Foto', this.selectedFile, this.selectedFile.name);
      }

      this.ref.close(formData); // envia o FormData para o componente pai
    } else {
      this.addEmpresaGestoraForm.markAllAsTouched();
      if (!this.selectedFile) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Por favor selecione uma imagem para o logotipo.',
        });
      }
    }
  }

  cancel() {
    this.ref.close();
  }
}
